import { render, staticRenderFns } from "./Individual.vue?vue&type=template&id=3a3bb4b2&scoped=true"
import script from "./Individual.vue?vue&type=script&lang=js"
export * from "./Individual.vue?vue&type=script&lang=js"
import style1 from "./Individual.vue?vue&type=style&index=1&id=3a3bb4b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3bb4b2",
  null
  
)

export default component.exports